import { lazy } from 'react';

const LiveSession = lazy(() => import('../routableComponents/LiveSession'));

export const routes = [
	{
		href: 'liveSession/:acsRoomId/:appointmentSpecialtyShortDesc',
		component: LiveSession,
	},
];
